// @flow
import {
    createStore as reduxCreateStore,
    applyMiddleware,
    compose,
    combineReducers
} from 'redux';
import thunk from 'redux-thunk';
import Reducers from './reducers';
import {middlewareAdapter} from '@homeaway/redux-middleware-adapter';
import registerAllMiddleware from './middleware/all';
import {pruneItem, getJSONItem} from './utils/localStorageWrapper';
import routes from './routes';
import {routerForBrowser} from 'redux-little-router';

import type {Store} from './reducers';

/**
 * Initialize the redux store.
 *   - connects middleware and reducers
 *   - configures the chrome extension for redux
 */

/* istanbul ignore next */
function createStore({
    request,
    initialState
}: {
    request: any,
    initialState: Object
}): Store {
    // Each middleware function is registered with the middlewareAdapter and
    // is assigned an action to respond to. See './middleware/all'
    registerAllMiddleware();

    // setup
    let composeEnhancers = compose;
    let router;
    if (typeof window !== 'undefined') {
        router = routerForBrowser({
            routes,
            basename: window.__SITE_CONTEXT__
                ? window.__SITE_CONTEXT__.basePath
                : ''
        });

        // Setup redux devtools chrome extension, if available and correct env
        if (initialState.system.environment === 'development') {
            composeEnhancers =
                window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        }

        // Add LocalStorage specific state
        pruneItem({itemKey: 'serpMapMarkers'});
        initialState.map.mapMarkersClicked =
            getJSONItem({itemKey: 'serpMapMarkers'}) || {};
    } else {
        const {routerForHapi} = require('redux-little-router');
        router = routerForHapi({routes, request});
    }

    // create middleware
    const createStoreWithMiddleware = composeEnhancers(
        router.enhancer,
        applyMiddleware(middlewareAdapter, router.middleware, thunk)
    )(reduxCreateStore);

    // create store
    const store = createStoreWithMiddleware(
        combineReducers(Object.assign({}, {router: router.reducer}, Reducers)),
        initialState
    );

    // Enable Webpack hot module replacement for reducers
    if (module.hot) {
        module.hot.accept('./reducers/index', () => {
            store.replaceReducer(Reducers);
        });
    }
    return store;
}
export {createStore};
